import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest } from "./AxiosConfiguration";

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {},
  reducers: {},
});

export default dashboardSlice.reducer;

export const fetchDashboardKPICards = createAsyncThunk(
  "dashboard/fetchKPICards",
  async ({ companyID = 0, startDate = null, endDate = null } = {}) => {
    try {
      const url = `Dashboard/Dashboard_ProjectGetKPICardDetails?companyID=${companyID}${
        startDate ? `&startDate=${startDate}` : ""
      }${endDate ? `&endDate=${endDate}` : ""}`;

      console.log("Fetching Dashboard KPI Cards from:", url);

      const result = await apiRequest("GET", url);

      console.log("Dashboard KPI Cards Response:", result);

      return result.data || result;
    } catch (error) {
      console.error("Dashboard KPI Cards Error:", error);
      throw error;
    }
  },
);

export const fetchProjectWiseHours = createAsyncThunk(
  "dashboard/fetchProjectWiseHours",
  async ({ companyID = 0 } = {}) => {
    try {
      const url = `Dashboard/Dashboard_GetProjectWiseHoursConsumption?companyID=${companyID}`;

      console.log("Fetching Project-wise Hours from:", url);

      const result = await apiRequest("GET", url);

      console.log("Project-wise Hours Response:", result);

      return result.data || result;
    } catch (error) {
      console.error("Project-wise Hours Error:", error);
      throw error;
    }
  },
);

export const fetchAllProjectWiseHours = createAsyncThunk(
  "dashboard/fetchAllProjectWiseHours",
  async ({ companyID = 0 } = {}) => {
    try {
      const url = `Dashboard/Dashboard_GetALLProjectWiseHoursConsumption?companyID=${companyID}`;

      console.log("Fetching All Project-wise Hours from:", url);

      const result = await apiRequest("GET", url);

      console.log("All Project-wise Hours Response:", result);

      return result.data || result;
    } catch (error) {
      console.error("All Project-wise Hours Error:", error);
      throw error;
    }
  },
);

export const fetchTestTypeAnalysis = createAsyncThunk(
  "dashboard/fetchTestTypeAnalysis",
  async ({ companyID = 0, projectID = 0 } = {}) => {
    try {
      const url = `Dashboard/Dashboard_GetTestTypeAnalysis?companyID=${companyID}&projectID=${projectID}`;

      console.log("Fetching Test Type Analysis from:", url);

      const result = await apiRequest("GET", url);

      console.log("Test Type Analysis Response:", result);

      return result.data || result;
    } catch (error) {
      console.error("Test Type Analysis Error:", error);
      throw error;
    }
  },
);

export const fetchLabKPIMetrics = createAsyncThunk(
  "dashboard/fetchLabKPIMetrics",
  async ({ companyID = 0, date = null } = {}) => {
    try {
      const url = `Dashboard/Dashboard_LabGetKPIMetrics?companyID=${companyID}${
        date ? `&date=${date}` : ""
      }`;

      console.log("Fetching Lab KPI Metrics from:", url);

      const result = await apiRequest("GET", url);

      console.log("Lab KPI Metrics Response:", result);

      return result.data || result;
    } catch (error) {
      console.error("Lab KPI Metrics Error:", error);
      throw error;
    }
  },
);

export const fetchTestEngineerKPIMetrics = createAsyncThunk(
  "dashboard/fetchTestEngineerKPIMetrics",
  async ({ companyID = 0, employeeID = 0 } = {}) => {
    try {
      const url = `Dashboard/Dashboard_TestEngineerGetKPIMetrics?companyID=${companyID}&employeeID=${employeeID}`;

      console.log("Fetching Test Engineer KPI Metrics from:", url);

      const result = await apiRequest("GET", url);

      console.log("Test Engineer KPI Metrics Response:", result);

      return result.data || result;
    } catch (error) {
      console.error("Test Engineer KPI Metrics Error:", error);
      throw error;
    }
  },
);
export const fetchLabOccupancyHeatmap = createAsyncThunk(
  "dashboard/Heatmap",
  async ({ companyId = 0, month = 1, year = 2026, shift = "all" } = {}) => {
    try {
      const url = `Dashboard/Heatmap?companyId=${companyId}&month=${month}&year=${year}&shift=${shift}`;

      console.log("Fetching Lab Occupancy Heatmap from:", url);

      const result = await apiRequest("GET", url);

      console.log("Lab Occupancy Heatmap Response:", result);

      return result.data?.data || result.data || result;
    } catch (error) {
      console.error("Lab Occupancy Heatmap Error:", error);
      throw error;
    }
  },
);

export const fetchLabShiftHeatmap = createAsyncThunk(
  "dashboard/fetchLabShiftHeatmap",
  async ({ companyId, month, year }, { rejectWithValue }) => {
    try {
      const response = await apiRequest(
        "GET",
        `/Dashboard/LabShiftHeatmap?companyId=${companyId}&month=${month}&year=${year}`,
      );
      return response.data?.data ?? [];
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || "Failed to load shift heatmap.",
      );
    }
  },
);

export const fetchLabWiseUtilization = createAsyncThunk(
  "dashboard/fetchLabWiseUtilization",
  async ({ companyID = 0, facilityID = 0 } = {}) => {
    try {
      const url = `Dashboard/Dashboard_GetLabWiseUtilization?companyID=${companyID}&facilityID=${facilityID}`;

      console.log("Fetching Lab-wise Utilization from:", url);

      const result = await apiRequest("GET", url);

      console.log("Lab-wise Utilization Response:", result);

      return result.data || result;
    } catch (error) {
      console.error("Lab-wise Utilization Error:", error);
      throw error;
    }
  },
);

export const fetchAllLabWiseUtilization = createAsyncThunk(
  "dashboard/fetchAllLabWiseUtilization",
  async ({ companyID = 0 } = {}) => {
    try {
      const url = `Dashboard/Dashboard_GetALLLabWiseUtilization?companyID=${companyID}`;

      console.log("Fetching All Lab-wise Utilization from:", url);

      const result = await apiRequest("GET", url);

      console.log("All Lab-wise Utilization Response:", result);

      return result.data || result;
    } catch (error) {
      console.error("All Lab-wise Utilization Error:", error);
      throw error;
    }
  },
);

export const fetchLabUtilizationRanking = createAsyncThunk(
  "dashboard/fetchLabUtilizationRanking",
  async ({ companyId = 0, fromDate = "", toDate = "" } = {}) => {
    try {
      const url = `Dashboard/GetLabUtilizationRanking?companyId=${companyId}${
        fromDate ? `&fromDate=${fromDate}` : ""
      }${toDate ? `&toDate=${toDate}` : ""}`;

      console.log("Fetching Lab Utilization Ranking from:", url);

      const result = await apiRequest("GET", url);

      console.log("Lab Utilization Ranking Response:", result);

      return result.data || result;
    } catch (error) {
      console.error("Lab Utilization Ranking Error:", error);
      throw error;
    }
  },
);

export const fetchBookingPipeline = createAsyncThunk(
  "dashboard/fetchBookingPipeline",
  async ({ companyId = 0 } = {}) => {
    const url = `Dashboard/GetBookingPipeline?companyId=${companyId}`;
    const result = await apiRequest("GET", url);
    const raw = result.data?.Data || result.data || result; // ✅ note capital D

    return {
      requested: raw.Requested,
      pendingApproval: raw.PendingApproval,
      approved: raw.Approved,
      running: raw.Running,
      completed: raw.Completed,
      conversionRate: raw.ConversionRate,
    };
  },
);

export const fetchResourceUtilFilters = createAsyncThunk(
  "dashboard/fetchResourceUtilFilters",
  async ({ companyId = 0 } = {}) => {
    try {
      const url = `Dashboard/GetFilters?companyId=${companyId}`;

      console.log("Fetching Resource Utilization Filters from:", url);

      const result = await apiRequest("GET", url);

      console.log("Resource Utilization Filters Response:", result);

      return result.data || result;
    } catch (error) {
      console.error("Resource Utilization Filters Error:", error);
      throw error;
    }
  },
);

export const fetchResourceUtilResult = createAsyncThunk(
  "dashboard/fetchResourceUtilResult",
  async ({
    EmpId = 0,
    selTestOfficer = "TO",
    TestTypeid = "",
    FacilityID = "",
    BusinessUnitID = "",
    Year = 0,
    Month = 0,
    type = "TESTTYPE",
    employeeid = 0,
    CompanyID = 0,
  } = {}) => {
    try {
      const qs = new URLSearchParams({
        EmpId,
        selTestOfficer,
        TestTypeid,
        FacilityID,
        BusinessUnitID,
        Year,
        Month,
        type,
        employeeid,
        CompanyID,
      }).toString();

      const url = `Dashboard/GetResult?${qs}`;

      console.log("Fetching Resource Utilization Result from:", url);

      const result = await apiRequest("GET", url);

      console.log("Resource Utilization Result Response:", result);

      return result.data || result;
    } catch (error) {
      console.error("Resource Utilization Result Error:", error);
      throw error;
    }
  },
);
export const fetchLabDrillDown = createAsyncThunk(
  "dashboard/fetchLabDrillDown",
  async ({ companyId, facilityId, fromDate, toDate }) => {
    const url = `Dashboard/GetLabDrillDown?companyId=${companyId}&facilityId=${facilityId}&fromDate=${fromDate}&toDate=${toDate}`;
    const result = await apiRequest("GET", url);
    return result.data?.data ?? result.data ?? result;
  },
);